import validate from "/opt/mc/app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "baas-sim-management-lite-auth": () => import("/opt/mc/app/middleware/baasSimManagementLiteAuth.ts")
}